import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/guidance',
  name: 'guidance',
  component: () => import('@/views/Guidance')
}, {
  path: '/download',
  name: 'download',
  component: () => import('@/views/Download')
}, {
  path: '/nutrition',
  name: 'nutrition',
  component: () => import('@/views/Nutrition')
}, {
  path: '/detail',
  name: 'detail',
  component: () => import('@/views/Detail')
}, {
  path: '/glossary',
  name: 'glossary',
  component: () => import('@/views/Glossary')
}, {
  path: '/privacy',
  name: 'privacy',
  component: () => import('@/views/Privacy')
}]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
